import Cat1 from './cat1.jpeg';
import Cat2 from './cat2.jpeg';
import Cat3 from './cat3.jpeg';
import Cat4 from './cat4.jpeg';
import Cat5 from './cat5.jpeg';
import Cat6 from './cat6.jpeg';
import Cat7 from './cat7.jpeg';

const catsImages = [
    Cat1,
    Cat2,
    Cat3,
    Cat4,
    Cat5,
    Cat6,
    Cat7,
];

export default catsImages;